"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringifyQueryHash = exports.parseQueryString = exports.head = exports.sortBy = exports.delay = exports.unique = exports.randomString = void 0;
function randomString() {
    return Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, "")
        .substr(0, 5);
}
exports.randomString = randomString;
function unique(array) {
    // https://stackoverflow.com/a/14438954
    return array.filter(function (value, index, self) { return self.indexOf(value) === index; });
}
exports.unique = unique;
function delay(milliseconds) {
    return new Promise(function (resolve) { return setTimeout(resolve, milliseconds); });
}
exports.delay = delay;
function sortBy(array, fn) {
    var cmp = function (a, b) {
        if (a < b) {
            return -1;
        }
        else if (a > b) {
            return 1;
        }
        else {
            return 0;
        }
    };
    return array.sort(function (a, b) { return cmp(fn(a), fn(b)); });
}
exports.sortBy = sortBy;
function head(array) {
    return [array[0], array.slice(1, array.length)];
}
exports.head = head;
exports.parseQueryString = function (queryString) {
    var data = {};
    var parsed = new URLSearchParams(queryString);
    parsed.forEach(function (value, key) {
        data[key] = value;
    });
    return data;
};
exports.stringifyQueryHash = function (queryHash) {
    var query = new URLSearchParams("");
    for (var _i = 0, _a = Object.entries(queryHash); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        query.set(key, value);
    }
    return query.toString();
};
